import React from 'react'
import LoadingSpinner from 'redesign/components/atoms/LoadingSpinner'
import HeaderWithBackButton from 'redesign/components/organisms/headers/header-with-back-button'
import Page from 'redesign/components/templates/Page'
import CmsContentView from 'redesign/components/templates/cms-content-view/cms-content-view'
import { STANDARD_PAGE_HORIZONTAL_PADDING } from 'shared/constants'
import type { CmsContentViewPageProps } from './types'
import useCmsContentViewPage from './use-cms-content-view-page'

const CmsContentViewPage: React.FC<CmsContentViewPageProps> = ({ match }) => {
  const {
    params: { contentUuid },
  } = match

  const { title, loading, content, blocks } = useCmsContentViewPage(contentUuid)

  if (loading) return <LoadingSpinner />

  return (
    <Page
      paddingX={STANDARD_PAGE_HORIZONTAL_PADDING}
      header={<HeaderWithBackButton title={title} />}
      hideNativeNavigation
    >
      <CmsContentView content={content} blocks={blocks} loading={loading} />
    </Page>
  )
}

export default CmsContentViewPage
